import { IUser } from "../models/common/IUserProfile";
import { connect } from "react-redux";
import { logoutUser } from "../action/common/keyClaokActionCreator";
import { UserRole } from "../constants/RoleEnum";
import { IUpdateUserProfile } from "../models/common/IUpdateUserProfile";
import { changeUserRole } from "../action/common/commonActionCreator";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../constants/routerUrl";
import { alertConstants, getAlertData } from "../helper/sweet-alert";
import { useCallback, useEffect, useState } from "react";
import { IDropdownData } from "../models/ICommon";
import { updateAISessions } from "../action/ai/aiConfigurationActionCreator";

const UserProfile = (props: IUser) => {
  const {
    logout,
    userInfo,
    changeUserRole,
    setShowAlert,
    setAlertTitle,
    setAlertType,
    setShowConfirm,
    updateAIChatSessions,
  } = props;
  const navigate = useNavigate();
  const [alertConstant, setAlertConstants] = useState<string>("");
  const role = userInfo.currentRole;
  const sortedRoles = [...userInfo?.roles].sort((a, b) =>
    a === userInfo?.currentRole
      ? -1
      : b === userInfo?.currentRole
      ? 1
      : UserRole[a].localeCompare(UserRole[b])
  );

  const navigateToLogin = () => {
    navigate(ROUTER_URL.LOGIN);
  };

  const callback = () => {
    let alertData = getAlertData(alertConstants.error);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const changeAttribute = (
    userRole: number,
    college?: IDropdownData,
    department?: IDropdownData
  ) => {
    if (
      userInfo.currentRole === userRole &&
      (college === undefined || userInfo?.currentCollege?.id === college?.id) &&
      (department === undefined ||
        userInfo?.currentDepartment?.id === department?.id)
    ) {
      return;
    }

    const userData: IUpdateUserProfile = {
      attributes: {
        currentRole: UserRole[userRole],
        userType: userRole,
        currentCollegeId: college ? college?.id : undefined,
        CurrentDepartmentId: department ? department?.id : undefined,
      },
      email: userInfo.email,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      emailVerified: true,
    };
    let alertData = null;
    if (college?.id != undefined) {
      alertData = getAlertData(
        alertConstants.custom,
        undefined,
        alertConstants.info,
        "College is switching to " + college.name
      );
    } else if (department?.id != null) {
      alertData = getAlertData(
        alertConstants.custom,
        undefined,
        alertConstants.info,
        "Department is switching to " + department.name
      );
    } else {
      alertData = getAlertData(
        alertConstants.custom,
        undefined,
        alertConstants.info,
        "Role is switching to " + UserRole[userRole]
      );
    }

    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }

    changeUserRole(userData, navigateToLogin, callback);
  };

  const userLogout = useCallback(async () => {
    try {
      await updateAIChatSessions();
    } finally {
      logout();
    }
  }, []);

  return (
    <>
      {(sortedRoles?.length > 1 ||
        userInfo?.colleges?.length >= 1 ||
        userInfo?.departments?.length >= 1) && (
        <>
          <div>
            <ul className="prof-list">
              <li>
                <span>{sortedRoles?.length > 1 ? "Roles" : "Role"}</span>
              </li>
              {sortedRoles?.map((role: number) => (
                <li key={role}>
                  <a onClick={() => changeAttribute(role)}>
                    {UserRole[role]}
                    {userInfo.currentRole === role ? (
                      <img src="/assets/images/checked.png" alt="" />
                    ) : (
                      <img
                        style={{
                          width: "10px !important",
                          height: "10px !important",
                        }}
                        src="/assets/images/icon/arrow-right.svg"
                        alt=""
                      />
                    )}
                  </a>
                </li>
              ))}
            </ul>

            {role === UserRole.CollegeAdmin &&
              userInfo.currentRole === UserRole.CollegeAdmin &&
              userInfo?.colleges?.length > 0 && (
                <ul className="prof-list">
                  <li>
                    <span>University Managements</span>
                  </li>
                  {userInfo?.colleges?.map((college) => (
                    <li>
                      <a
                        key={college?.id}
                        className="d-flex justify-content-between align-items-center"
                        onClick={() =>
                          changeAttribute(role, college, undefined)
                        }
                      >
                        {college?.name}
                        {userInfo?.currentCollege?.id === college?.id ? (
                          <img
                            style={{ width: "25px", height: "25px" }}
                            src="/assets/images/checked.png"
                            alt=""
                          />
                        ) : (
                          <img
                            style={{
                              width: "10px !important",
                              height: "10px !important",
                            }}
                            src="/assets/images/icon/arrow-right.svg"
                            alt=""
                          />
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            {role === UserRole.DepartmentAdmin &&
              userInfo.currentRole === UserRole.DepartmentAdmin &&
              userInfo.departments.length > 0 && (
                <ul className="prof-list">
                  <li>
                    <span>Departments</span>
                  </li>
                  {userInfo?.departments?.map((department) => (
                    <li>
                      <a
                        key={department?.id}
                        className="d-flex justify-content-between align-items-center"
                        onClick={() =>
                          changeAttribute(role, undefined, department)
                        }
                      >
                        {department.name}
                        {userInfo?.currentDepartment?.id === department?.id ? (
                          <img
                            style={{ width: "25px", height: "25px" }}
                            src="/assets/images/checked.png"
                            alt=""
                          />
                        ) : (
                          <img
                            style={{ width: "25px", height: "25px" }}
                            src="/assets/images/icon/arrow-right.svg"
                            alt=""
                          />
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
          </div>
        </>
      )}
      <a className="img-logout" onClick={() => userLogout()}>
        <img src="/assets/images/icon/logout.svg" alt="" />
        <div>
          <h6 className="text-dark">Logout</h6>
          <span>{userInfo?.email}</span>
        </div>
      </a>
    </>
  );
};

const mapDispatchToProps = {
  logout: () => logoutUser(),
  updateAIChatSessions: () => updateAISessions(),
  changeUserRole: (
    userData: IUpdateUserProfile,
    navigateToLogin: Function,
    callback: Function
  ) => changeUserRole(userData, navigateToLogin, callback),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
